import { Route } from '~/apps/pu-links/domain/Route'

export function getMetaFromRoute(nextRoute: Route) {
  return nextRoute.meta && Array.isArray(nextRoute.meta)
    ? (nextRoute.meta || [{}]).reduce(
        (acc: any, obj: any) => Object.assign(acc, obj),
        {},
      )
    : nextRoute.meta || {}
}
